import { Suspense, useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router';
import { Loading } from '@wfp/ui';
import { useRoutesContext } from '../../context/routesContext';
import { useUserProfile } from '../../context/UserProfileContext/UserProfileContext';
import { FullLayout } from '../../Layout/FullLayout';
import { PrivateRoute } from './PrivateRoute';
import { useAuth } from 'react-oidc-context';
import { SIGN_IN_CALLBACK_RETURN_URL } from '../../constants/auth';
import { replaceUrl } from '../../utils/navigation';

export const RoutesList = () => {
  const { routes, defaultRoute } = useRoutesContext();

  const location = useLocation();

  const { user, isAuthenticated } = useAuth();

  const { isLoading } = useUserProfile();

  useEffect(() => {
    if (isAuthenticated && location.pathname.includes('/auth/callback')) {
      replaceUrl(
        (user?.state as { [SIGN_IN_CALLBACK_RETURN_URL]?: string })?.[
          SIGN_IN_CALLBACK_RETURN_URL
        ] ??
          defaultRoute.path ??
          ''
      );
    }
  }, [isAuthenticated, location.pathname, defaultRoute.path, user?.state]);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        {routes?.map(
          ({
            path,
            component: Component,
            isPrivate,
            permissionCheck = null
          }) => {
            if (isPrivate) {
              return (
                <Route
                  key={path}
                  path={path}
                  element={
                    <PrivateRoute permissionCheck={permissionCheck}>
                      <FullLayout>
                        <Component />
                      </FullLayout>
                    </PrivateRoute>
                  }
                />
              );
            }
            return (
              <Route
                key={path}
                path={path}
                element={
                  <FullLayout>
                    <Component />
                  </FullLayout>
                }
              />
            );
          }
        )}
        {!isLoading && (
          <Route path="/" element={<Navigate to={defaultRoute.path} />} />
        )}
      </Routes>
    </Suspense>
  );
};
